/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping your custom
* Javascript in this file will make it easier to update Broadcast.
*/

(function() {

  /* =========================
     CART UPSELL SLIDER
  ========================== */

  function getSliderParts(slider) {
    const track = slider.querySelector('[data-dr-upsell-track]');
    if (!track) return null;

    const items = Array.from(track.querySelectorAll('.dr-upsell__item'));
    if (!items.length) return null;

    const prevButton = slider.querySelector('[data-dr-upsell-prev]');
    const nextButton = slider.querySelector('[data-dr-upsell-next]');

    return {
      track,
      items,
      prevButton,
      nextButton
    };
  }

  function getCurrentIndex(track, items) {
    let closestIndex = 0;
    let closestDistance = Infinity;

    items.forEach(function(item, index) {
      const distance = Math.abs(item.offsetLeft - track.scrollLeft);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function goToIndex(slider, index) {
    const parts = getSliderParts(slider);
    if (!parts) return;

    const maxIndex = parts.items.length - 1;
    const safeIndex = Math.max(0, Math.min(index, maxIndex));
    const targetItem = parts.items[safeIndex];

    parts.track.dataset.drCurrentIndex = safeIndex;

    parts.track.scrollTo({
      left: targetItem.offsetLeft,
      behavior: 'smooth'
    });

    updateButtons(slider, safeIndex);
  }

  function updateButtons(slider, index) {
    const parts = getSliderParts(slider);
    if (!parts) return;

    const currentIndex = typeof index === 'number'
      ? index
      : getCurrentIndex(parts.track, parts.items);

    if (parts.prevButton) {
      parts.prevButton.disabled = currentIndex <= 0;
    }

    if (parts.nextButton) {
      parts.nextButton.disabled = currentIndex >= parts.items.length - 1;
    }
  }

  document.addEventListener('click', function(event) {
    const prevButton = event.target.closest('[data-dr-upsell-prev]');
    const nextButton = event.target.closest('[data-dr-upsell-next]');

    if (!prevButton && !nextButton) return;

    const slider = event.target.closest('[data-dr-upsell-slider]');
    if (!slider) return;

    const parts = getSliderParts(slider);
    if (!parts) return;

    const storedIndex = parseInt(parts.track.dataset.drCurrentIndex || '', 10);
    const currentIndex = Number.isNaN(storedIndex)
      ? getCurrentIndex(parts.track, parts.items)
      : storedIndex;

    const nextIndex = nextButton ? currentIndex + 1 : currentIndex - 1;

    goToIndex(slider, nextIndex);
  });

  document.addEventListener('scroll', function(event) {
    const track = event.target.closest && event.target.closest('[data-dr-upsell-track]');
    if (!track) return;

    const slider = track.closest('[data-dr-upsell-slider]');
    if (!slider) return;

    const parts = getSliderParts(slider);
    if (!parts) return;

    window.clearTimeout(track._drSliderScrollTimer);

    track._drSliderScrollTimer = window.setTimeout(function() {
      const index = getCurrentIndex(parts.track, parts.items);
      parts.track.dataset.drCurrentIndex = index;
      updateButtons(slider, index);
    }, 100);
  }, true);

  document.addEventListener('touchend', function(event) {
    const track = event.target.closest && event.target.closest('[data-dr-upsell-track]');
    if (!track) return;

    const slider = track.closest('[data-dr-upsell-slider]');
    if (!slider) return;

    const parts = getSliderParts(slider);
    if (!parts) return;

    window.setTimeout(function() {
      const index = getCurrentIndex(parts.track, parts.items);
      goToIndex(slider, index);
    }, 120);
  }, { passive: true });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-dr-upsell-slider]').forEach(function(slider) {
      const parts = getSliderParts(slider);
      if (!parts) return;

      parts.track.dataset.drCurrentIndex = 0;
      updateButtons(slider, 0);
    });
  });

  document.addEventListener('shopify:section:load', function() {
    document.querySelectorAll('[data-dr-upsell-slider]').forEach(function(slider) {
      const parts = getSliderParts(slider);
      if (!parts) return;

      const index = getCurrentIndex(parts.track, parts.items);
      parts.track.dataset.drCurrentIndex = index;
      updateButtons(slider, index);
    });
  });

})();